<template>
  <div
    class="mt-4 mx-3 row white-box px-3 py-4"
    v-if="crmCategories !== undefined"
  >
    <div class="white-box-top"></div>
    <div class="col-md-4 col-lg-2">
      <nav class="left-nav">
        <button
          v-for="crmCategory in crmCategories"
          :key="crmCategory.id"
          class="btn w-100 text-start"
          v-on:click="active = crmCategory.slug"
          :class="active === crmCategory.slug ? 'btn-primary' : 'btn-simple'"
        >
          {{ crmCategory.name }}
        </button>
        <button
          class="btn w-100 text-start"
          :class="!active ? 'btn-primary' : 'btn-simple'"
          v-on:click="active = null"
        >
          + new CRM category
        </button>
      </nav>
    </div>
    <div class="col-md-8 col-lg-10" v-if="active === null">
      <h2>
        {{ $t("crm.crm") }}
      </h2>
      <h4>Create new CRM category</h4>
      <div class="row text-start custom-input whitebg-input mt-4">
        <div class="row mb-3">
          <div class="col-4 mb-3">
            <label class="form-label bold-12 text-gray">
              {{ $t("session.type") }}
            </label>
            <v-select
              :options="[
                { id: 1, name: 'Partner' },
                { id: 2, name: 'Team' },
                { id: 3, name: 'Customer' },
              ]"
              v-model="newCategory.type"
              label="name"
              :placeholder="$t(`session.type`)"
              :reduce="(c) => c.id"
              append-to-body
            />
          </div>
          <div class="col-5 mb-3">
            <label class="form-label bold-12 text-gray">
              {{ $t("session.name") }}
            </label>
            <input
              type="text"
              class="form-control remove-padding"
              :placeholder="$t(`session.name`)"
              v-model="newCategory.name"
              v-on:focusout="generateSlug()"
            />
          </div>
          <div class="col-3 mb-3">
            <label class="form-label bold-12 text-gray">{{
              $t("webshops.urlSlug")
            }}</label>
            <input
              type="text"
              class="form-control remove-padding"
              placeholder="w-hu"
              v-model="newCategory.slug"
            />
          </div>
          <div class="row">
            <label
              v-for="p in icons"
              :key="p"
              class="col-2 col-md-1 mb-1 text-center"
            >
              <div
                class="
                  border
                  rounded
                  p-3
                  h-100
                  d-flex
                  flex-column
                  align-items-start
                  printer-card
                  text-center
                "
                :class="{ 'border-primary': newCategory.icon === p }"
              >
                <input
                  type="radio"
                  class="form-check-input mb-2"
                  :value="p"
                  v-model="newCategory.icon"
                />
                <BaseIcon :name="p" />
              </div>
            </label>
          </div>
          <div class="row mt-2">
            <div class="col"></div>
            <div class="col-auto">
              <button
                :class="{ 'loading-spin': loadAddBtn }"
                :disabled="loadAddBtn"
                class="btn btn-primary"
                v-on:click="createCategory"
              >
                <span>{{ $t("addRole.create") }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-8 col-lg-10" v-else>
      <h2>
        {{ $t("crm.crm") }}
      </h2>
      <custom-rows v-model:type="active" />
    </div>
  </div>
</template>

<script>
import CustomRows from "@/components/settings/products/CustomRows";
import { useStore } from "vuex";
import BaseIcon from "../icons/BaseIcon.vue";
import http from "@/modules/http";
export default {
  name: "Crm",
  components: { BaseIcon, CustomRows },
  data() {
    return {
      store: useStore(),
      active: "partners",
      newCategory: {},
      loadAddBtn: false,
      icons: [
        "partners",
        "customers",
        "partner-add",
        "user-tick",
        "web",
        "bag",
        "user-search",
        "map",
        "shop",
        "clock",
        "messages",
        "share",
        "mail",
      ],
    };
  },
  computed: {
    crmCategories() {
      return this.store.state.crmCategories;
    },
  },
  methods: {
    createCategory() {
      this.loadAddBtn = true;
      http
        .fetch("/crm/categories", this.newCategory, true)
        .then((data) => {
          this.$store.commit("addCrmCategory", data);
          this.newCategory = {};
          this.loadAddBtn = false;
        })
        .catch(() => {
          this.loadAddBtn = false;
        });
    },
    generateSlug() {
      if (this.newCategory.slug === undefined) {
        this.newCategory.slug = this.newCategory.name
          .toLowerCase()
          .replace(/ /g, "-")
          .replace(/[^\w-]+/g, "");
      }
    },
  },
};
</script>
